<template>
  <div class="input-group">
    <label v-if="label">{{ label }}</label>
    <div class="input" :class="[
      classBindings,
      {
        'border-danger': invalid,
        'border-primary': success,
      }
    ]">
      <div
        class="input-prepend flex-shrink-0"
        v-if="this.$slots['input:prepend']">
        <slot name="input:prepend"></slot>
      </div>
      <template v-if="textarea">
        <textarea
          :placeholder="placeholder"
          :disabled="disabled"
          :rows="rows"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-inputmask="inputmask"
          v-if="!!inputmask"></textarea>
        <textarea
          :placeholder="placeholder"
          :disabled="disabled"
          :rows="rows"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-else></textarea>
      </template>
      <template v-else>
        <input
          :type="type"
          :placeholder="placeholder"
          :disabled="disabled"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-inputmask="inputmask"
          v-if="!!inputmask">
        <input
          :type="type"
          :placeholder="placeholder"
          :disabled="disabled"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-else>
      </template>
      <div
        class="input-append flex-shrink-0"
        v-if="this.$slots['input:append']">
        <slot name="input:append"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false,
    },
    success: {
      type: Boolean,
      required: false,
      default: false,
    },
    classes: {
      type: [String, Array],
      required: false,
    },
    inputmask: {
      type: [String, Object],
      required: false,
    },
    textarea: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  data() {
    return {
      content: null,
    };
  },
  computed: {
    classBindings() {
      if (typeof this.classes === 'string') {
        return this.classes;
      }
      return this.$classnames(this.classes);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      immediate: true,
    },
  },
};
</script>
